module.exports = __webpack_public_path__ + "static/media/Accademia - Bordeaux_White.5cbff24a.jpg";